<template>
  <div class="insumo">
    <div class="insumo-info">
      <div class="insumo-imagem">
        <img async :src="insumo.Imagem" alt="" />
      </div>
      <div class="text-left">
        <div class="row">
          <div class="col-md-12">
            <span> {{ insumo.SubGrupo }} {{ insumo.Descricao }} </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 insumo-attr">
            <span class="new-badge"> {{ insumo.Disponibilidade }} <i class="fa fa-check"></i></span>
            <span class="new-badge"> {{ insumo.Garantia }} DE GARANTIA <i class="fa fa-check"></i></span>
            <span v-if="associado" class="new-badge"> PRODUTO ASSOCIADO <i class="fa fa-check"></i></span>
            <span v-if="insumo.LinkFolheto" class="folhetos_produto">
              <a v-bind:href="insumo.LinkFolheto" target="_blank">Folhetos <i class="fa fa-external-link"></i></a
            ></span>
          </div>
        </div>
      </div>
    </div>

    <div class="insumo-quantitativo">
      <span class="insumo-unidade">
        {{ insumo.Unidade }}
      </span>
      <span class="insumo-qtde">
        {{ insumo.Quantidade }}
      </span>
      <!--<span class="insumo-valor-unitario"> R$ {{ insumo.ValorUnitarioFormatado }} </span>
      <span class="insumo-valor-total"> R$ {{ insumo.ValorFormatado }} </span>-->
    </div>
  </div>
</template>

<style type="text/css" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.insumo {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 6px;
  height: 100px;
  justify-content: space-between;
}

.insumo-imagem {
  padding: 0 10px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 130px !important;
  min-width: 130px !important;
  max-width: 130px !important;
}

.insumo-imagem img {
  max-height: 98px;
  cursor: pointer;
  transition: 0.6s;
}

.insumo-imagem img:hover {
  transform: scale(1.08);
}

.insumoborder {
  border-bottom: 1px #ccc solid;
}

.insumo-unidade,
.insumo-info,
.insumo-quantitativo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: right;
}

.insumo-unidade,
.insumo-qtde,
.insumo-valor-unitario,
.insumo-valor-total {
  width: 100px;
}

.insumo-unidade,
.insumo-qtde {
  width: 40px;
  justify-content: center;
}

.insumo-qtde {
  width: 55px;
}

.insumo-attr {
  margin-top: 5px !important;
}

.new-badge {
  background-color: #50a3d3;
  border-radius: 10px;
  color: white;
  display: inline-flex;
  font-size: 10px;
  font-weight: bold;
  justify-content: center;
  margin-right: 15px;
  padding: 3px 15px;
  width: 170px;
}

.new-badge .fa-check {
  color: rgb(108, 245, 108);
  margin-left: 5px;
  font-size: 15px;
}

.folhetos_produto {
  font-weight: bold;
  font-size: 12px;
  color: white;
  padding: 3px 15px 0 10px;
  border-radius: 10px;
  background-color: transparent;
}

.folhetos_produto .fa-external-link {
  margin-left: 5px;
  font-size: 15px;
}

@media (max-width: 600px) {
  .produto-custom .odd {
    background-color: #d8f1fe;
  }
}

@media (max-width: 600px) {
  .produto-custom .produto-descricao {
    font-size: 12px;
    grid-column: span 2;
  }

  .produto-custom .produto-attr {
    flex-direction: column;
    gap: 4px;
  }

  .produto-custom .produto-actions {
    grid-column: span 2;
    justify-content: center;
  }

  .produto-custom {
    grid-template-columns: 90px 80px auto;
  }

  .produto-imagem,
  .produto-custom .produto-descricao {
    height: 140px;
  }

  .produto-custom .produto-actions,
  .produto-custom .produto-valores {
    height: 100px;
  }
}
</style>

<script>
export default {
  name: 'ProductInputResume',

  props: {
    insumo: { type: Object, name: 'produto' },
    index: { type: Number, name: 'index' },
    associado: { type: Boolean, name: 'associado' },
  },
}
</script>
